export default __webpack_public_path__ + "66adfe4e485e3923b64210ed0cd923b7.png";